import React from "react";
import { classNameForValidationErrors } from "../../common/components/componentUtils";
import Label from "../../common/components/Label";
import classNames from "classnames";

const radioLabelStyles = {width: "auto", textAlign:"left"};

const ConflictOfInterest = (props) => (
    <div className={ classNames("pure-control-group", classNameForValidationErrors(props.recommendation.hasConflictOfInterest), "x-recommendation-conflict-of-interest") }>
        <Label style={{verticalAlign: "top"}}>
            Conflict of Interest
        </Label>
        <div style={{display: "inline-block", width: "25em"}}>
            <div style={{color: "#888", marginBottom: "0.5em"}}>Do you, your group or anyone associated with you have any conflict of interest regarding the recommendation?</div>
            <Label style={radioLabelStyles}>
                <input {...props.recommendation.hasConflictOfInterest}
                       type="radio"
                       value="no"
                       checked={props.recommendation.hasConflictOfInterest.value === "no"} />
                &nbsp;No
            </Label>

            <Label style={radioLabelStyles}>
                <input {...props.recommendation.hasConflictOfInterest}
                       type="radio"
                       value="yes"
                       checked={props.recommendation.hasConflictOfInterest.value === "yes"} />
                &nbsp;Yes
            </Label>

            <div className={ (props.recommendation.hasConflictOfInterest.value === "yes") ? classNameForValidationErrors(props.recommendation.conflictOfInterestDescription) : "" }
                 style={{display: "inline-block"}} >
                <input {...props.recommendation.conflictOfInterestDescription}
                       disabled={ props.recommendation.hasConflictOfInterest.value !== "yes" }
                       placeholder={ props.recommendation.hasConflictOfInterest.value !== "yes" ? "" : "Description (not sent to client)"}
                       className="idea-attribute__input"
                       style={{width: 205}}
                       type="text" />
            </div>
        </div>
    </div>
);

ConflictOfInterest.propTypes = {
    conflictOfInterestDescription: React.PropTypes.string,
    hasConflictOfInterest: React.PropTypes.bool,
    onChange: React.PropTypes.func,
    onDescriptionChange: React.PropTypes.func
};

export default ConflictOfInterest;



/** WEBPACK FOOTER **
 ** ./src/main/javascript/recorder/components/ConflictOfInterest.js
 **/